import { executeCommand } from 'owa-calendar-command-executor';
import type { OwaDate } from 'owa-datetime';

export interface GridClickParams {
    start: OwaDate;
    end: OwaDate;
    isAllDay: boolean;
    isClickAndDragEvent: boolean;
    selectedCalendarFolderId?: string;
}

/**
 * This adapter simplifies the wrapping of surface handlers to account for scenario-specific concerns.
 */
export default function SurfaceGridHandlerAdapter(
    scenario: string,
    handler: (scenario: string, params: GridClickParams) => void
): (params: GridClickParams) => void {
    if (!handler) {
        return () => null;
    }

    return function (params: GridClickParams) {
        // execute command after a single-tick delay to unify handling of multiple handlers
        executeCommand(() => handler(scenario, params), 0);
    };
}
